export const GET_NUMERI_DATA_AND_LOADING = "GET_NUMERI_DATA_AND_LOADING";
export const CREATE_NEW_GROUP = "CREATE_NEW_GROUP";
export const GET_NUMERI_DETAILS = "GET_NUMERI_DETAILS";
export const MODIFY_NUMBER = "MODIFY_NUMBER";
export const GET_TAGS_FOR_NUMBERS = "GET_TAGS_FOR_NUMBERS";
export const ADD_TAGS_TO_NUMBERS = "ADD_TAGS_TO_NUMBERS";
export const EXPORT_NUMERI_LOADING = "EXPORT_NUMERI_LOADING";
